// extracted by mini-css-extract-plugin
export default {"container":"interior2_container__phFpR","text":"interior2_text__Hmn0l","Wrapper":"interior2_Wrapper__CYMeb","comp":"interior2_comp__GW1wn","compText":"interior2_compText__Q7wLT"};